import { render } from "./Index.vue?vue&type=template&id=8a6764ea&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=8a6764ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a6764ea"],['__file',"components/Auth/Register/Vendor/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a6764ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a6764ea', __exports__)) {
    api.reload('8a6764ea', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=8a6764ea&scoped=true", () => {
    api.rerender('8a6764ea', render)
  })

}


export default __exports__